import React, { memo } from 'react';
import styles from '../../DataExtractionTemplate.module.scss';
import SectionTitle from '../SectionTitle';
import Wizard from '../Wizard/Wizard';
import InterventionsPopoversList from './InterventionsPopoversList';
import InterventionsMainContent from './InterventionsMainContent';
import { useInterventionWizardContext } from './InterventionWizardProvider';
import {
  interventionsPendoKeys,
  interventionsWizardData,
} from './InterventionsWizardData';
import { Button, Text } from 'components/core';

interface Props {
  hasExtractedData?: boolean;
}

const InterventionsPanel = ({ hasExtractedData = false }: Props) => {
  const wizard = useInterventionWizardContext();

  return (
    <section id="interventions" className={styles.Panel}>
      <SectionTitle
        title="Interventions"
        showPreview={wizard.showHeaderButtons}
        pendoKey="det-interventions"
        ariaLabel="Get help with interventions"
      >
        {wizard.showHeaderButtons && (
          <Button
            size="sm"
            type="primary"
            variant="outline"
            onClick={() => {
              wizard.setWizardOpen(true);
            }}
            aria-label="Edit set up"
            data-pendo-key={interventionsPendoKeys.editSetup}
          >
            <Text size="sm">Edit set up</Text>
          </Button>
        )}
      </SectionTitle>

      <InterventionsPopoversList />

      <div className={styles.details}>
        {wizard.shouldForceWizardUse && (
          <Button
            type="primary"
            onClick={() => wizard.setWizardOpen(true)}
            data-pendo-key={interventionsPendoKeys.setupNow}
          >
            Set up now
          </Button>
        )}

        {!wizard.shouldForceWizardUse && !wizard.isWizardOpen && (
          <InterventionsMainContent hasExtractedData={hasExtractedData} />
        )}

        <Wizard
          id="interventions-wizard"
          data={interventionsWizardData({ hasExtractedData })}
          pendoKey={interventionsPendoKeys}
          isOpen={wizard.isWizardOpen}
          onClose={() => {
            wizard.setWizardHasBeenDisplayed(true);
            wizard.setWizardOpen(false);
          }}
        />
      </div>
    </section>
  );
};

export default memo(InterventionsPanel);
